function AlertIcon() {
  return (
    <svg
      width="36"
      height="33"
      viewBox="0 0 36 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 20.3335L18 13.6668"
        stroke="#9F73E6"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.7801 28.8263C34.1722 29.4929 33.6916 30.3333 32.9182 30.3333H3.08167C2.30825 30.3333 1.8276 29.4929 2.21973 28.8263L17.138 3.46529C17.5246 2.80798 18.4752 2.80798 18.8619 3.46529L33.7801 28.8263Z"
        stroke="#9F73E6"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9993 27C19.1038 27 19.9993 26.1046 19.9993 25C19.9993 23.8954 19.1038 23 17.9993 23C16.8947 23 15.9993 23.8954 15.9993 25C15.9993 26.1046 16.8947 27 17.9993 27Z"
        fill="#9F73E6"
      />
    </svg>
  );
}

export default AlertIcon;
